import React, { useEffect } from 'react';
import { defaults, Line, Bar, Doughnut } from 'react-chartjs-2';
import { fontString } from 'chart.js/helpers';
import AppBar from '@material-ui/core/AppBar';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Container from '@material-ui/core/Container';
import api from './../../../services/axios'
import Loading from './../../../compoments/Loading';
import NavBack from './../../NavBack';
import {ajeitaLegenda} from '../graficosutil'


const drawerWidth = 240;
defaults.font.size = 24

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    backgroundColor: '#F2F2F2',
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
}));

function prettyTime(secs) {
  var s = Math.floor(secs % 60)
  var m = Math.floor(secs / 60) % 60
  var h = Math.floor(secs / 3600)
  return ((h < 10) ? "0" + h : "" + h) + ":" + ((m < 10) ? "0" + m : "" + m) + ":" + ((s < 10) ? "0" + s : "" + s)
}

const options = {
  plugins:{
    tooltip:{
      mode:'index'    
    }
  },
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    y: {
      position: 'left',
      scalePositionLeft:false,
      type:'linear',      
    },
    y1: {
        id: 'y1',
        position: 'right',
        scalePositionLeft:false,
        type:'linear',
        ticks:{
          callback:function(value){
            return value + ' %'
          }
        }
      },    
  },
  
};


const colors = [
  "#93c2f1", // azul claro
  "#36494e", // azul 1
  "#eee1b3", // amarelo
  "#b4869f", // rosa
  "#597081", // azul 2
  "#c6dea6", // verde claro
  "#ced097", // bege
  "#149911", // verde
  "#a52740", // vinho
  "#ED6A5A"  // salmão
]

function dateISOtoddmmyyyy(d){
  var ymd = d.split('-')
  return ymd[2] + '/' + ymd[1]// + '/' + ymd[0]
}

function setColor(obj,color){
  obj.backgroundColor = color
  obj.borderColor = color
}

function renderGrafico(tipo,da){
  if(da == null)
    return <></>
  if(tipo == 'volAtdGeral'){
    
    var data = {labels:da.datas,datasets:[
      {label:'Atendidas (ativas + receptivas)',data:da.ReceptivaAtendida.map((v,i)=>v + da.AtivaAtendida[i])},
      {label:'Ativas atendidas',data:da.AtivaAtendida},
      {label:'Receptivas atendidas',data:da.ReceptivaAtendida},
      {label:'Receptivas abandonadas',data:da.ReceptivaAbandonada},
      {label:'Taxa de abandono',data:da.TaxaAbandono,yAxisID:'y1'}
    ]}
    if(da.datas[0] && typeof da.datas[0] != 'number'){
      data.labels = da.datas.map(dateISOtoddmmyyyy)
    }else{
      data.labels = da.datas.map((d)=> (d < 10 ? '0'+d : d)+':00' )
    }
    setColor(data.datasets[0],colors[1])
    setColor(data.datasets[1],colors[0])
    setColor(data.datasets[2],colors[7])
    setColor(data.datasets[3],colors[6])
    setColor(data.datasets[4],colors[8])

    return <Line data={data} 
      options={options}
      plugins={[ajeitaLegenda]}
     />    
  }else if(tipo == 'volAtdUsuario'){    
    var data = {labels:da.nomes,datasets:[
      {label: "Chamadas receptivas", data:da.rtv},
      {label: "Chamadas ativas", data:da.atv},
    ]}
    setColor(data.datasets[0],colors[0])
    setColor(data.datasets[1],colors[5])
    return <Bar data={data} 
      options={{
        responsive: true,
        maintainAspectRatio: false,
        animation:{
          onProgress:function() {
            //console.log(this)
            var chartInstance = this
            var ctx = this.ctx
    
            ctx.font = fontString(defaults.font.size * 0.7, defaults.font.style, defaults.font.family);
            ctx.textAlign = 'center';
            ctx.textBaseline = 'bottom';
    
            var d = []
            var total = 0
            var min = (a,b) => a < b ? a : b
            this.data.datasets.forEach(function(dataset, i) {
              var meta = chartInstance.getDatasetMeta(i);              
              meta.data.forEach(function(bar, index) {                
                var data = dataset.data[index];
                d[index] = (d[index]) ? d[index] : {}

                d[index].x = bar.x                
                d[index].y = d[index].y ? min(d[index].y,bar.y) : bar.y
                
                d[index].sum = d[index].sum ? d[index].sum : 0
                d[index].sum += data*1

                total += data*1
              });
            });
            for (const item of d) {
              ctx.fillText(((item.sum / total)*100).toFixed(1).replace('.',',') + "%", item.x, item.y - 5);
            }
          }
        },
        scales:{
          x:{
            stacked: true
          },
          y:{
            stacked:true
          }
        }
      }}
     />
  }else if(tipo == 'tiposPausa'){
    var data = {labels:da.tipos,datasets:[
        {data: da.duracao,backgroundColor:colors}
    ]}
    var total = da.duracao.reduce((a,b)=>a+b,0)
    return <div style={{height:'70vh'}}><Doughnut data={data} 
      options={{
        responsive:true,
        maintainAspectRatio: false,
        plugins:{
          tooltip:{
            callbacks:{
              label:function(ctx){
                return ctx.label + ': '+(ctx.raw/total*100).toFixed(1).replace('.',',')+'%'
              }
            }
          }
        }
      }}
     /></div>
  }else if(tipo == 'tempoMedio'){    
    var data = {labels:da.datas,datasets:[
      {label:'Tempo médio de espera',data:da.tme},
      {label:'Tempo médio de atendimento',data:da.tma},
    ]}
    data.labels = da.datas.map(dateISOtoddmmyyyy)
    setColor(data.datasets[0],colors[8])
    setColor(data.datasets[1],colors[0])    

    return <Line data={data} 
      options={
        {
          plugins:{
            tooltip:{
              callbacks:{
                label:function(ctx){
                  return ctx.label + ': ' + prettyTime(ctx.raw)
                }
              }
            }
          },
          responsive: true,
          maintainAspectRatio: false, 
          scales:{
            y:{
              id: 'y',
              position: 'left',
              scalePositionLeft:false,
              type:'linear',
              ticks:{
                callback:function(value){
                  return prettyTime(value)
                }
              }
            },          
          }
        }
      }
     />    
  }
}

export default function Vag() {  
  const  [open, setOpen] = React.useState(false);
  const graficos = ['volAtdGeral']
  const titleHeader = 'Voltar'
  const classes = useStyles();

  var [grafico, setGrafico] = React.useState(graficos[0])
  
  const dateToString = (date, time, format = false) => {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    
    let timeString = '';
    if (time) {
      timeString = ' ' + hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0');
    }
    if (!format) {
      return yyyy + '-' + mm + '-' + dd + '' + timeString;
    }
    return dd + '/' + mm + '/' + yyyy + ' ' + timeString;
  }

  const addDays = function (date, daysToAdd) {
    var _24HoursInMilliseconds = 86400000;
    return new Date(date.getTime() + daysToAdd * _24HoursInMilliseconds);
  }
  
  const loadData = async () => {
    setLoading(true)
    const { data } = await api.get('v1/graficos/'+grafico+'?start=' + start + '&end='+end)
    setLoading(false)
    setDa(data)
  }
  const trocaTela = () => {
    graficos.push(graficos.shift())
    grafico = graficos[0]
    setDa(null)
    setGrafico(graficos[0])
    loadData()
  }
  useEffect(() => {       
    var now = new Date()
    var start = new Date()

    start.setDate(now.getDate() - 30)
    setStart(start.toISOString().substring(0,10))
    setEnd(now.toISOString().substring(0,10))       
    loadData()      
    return () => {      
    }
  }, [])

  const [da, setDa] = React.useState(null);

  const [loading, setLoading] = React.useState(true);
  var [start, setStart] = React.useState("");
  var [end, setEnd] = React.useState("");
  
  const changeTime = function(value,t){
    if(t == 'start'){
      setStart(value)
      start = value
    }else{
      setEnd(value)
      end = value
    }
    loadData()
  }
  return (
    <>
      <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
        <NavBack
          titleHeader={titleHeader}
        />        
      </AppBar>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} >
          <Container maxWidth={false} className={classes.container}>            
            <div style={{ padding: '64px 40px',height:'80vh'}}>     
                <>
                  <div className='header' style={{ paddingTop: 20,height: '10rem' }}>
                    <h1 className='title'>Volume de atendimento geral</h1>
                    Do dia&nbsp;
                    <input type="date" onChange={(e)=>changeTime(e.target.value,'start')} value={start} />&nbsp;
                    até o dia&nbsp;
                    <input type="date" onChange={(e)=>changeTime(e.target.value)} value={end} />
                    <input type="button" onClick={loadData} value="Atualizar" />
                  </div>
                {loading ? <Loading /> :
                  <div style={{height: '100%',maxHeight:'100%',}}>
                    {renderGrafico(grafico,da)}
                  </div> }                  
                </>
            </div>
          </Container>
        </div>
      </main>
    </>
  )
}